"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.EventEmitter = void 0;
const emittery_1 = __importDefault(require("emittery"));
/**
 * This provides a starting point for classes that emit events.
 */
class EventEmitter {
    constructor() {
        /**
         * Subscribe to an event. An unsubscribe function is returned.
         */
        this.on = (eventName, listener) => this.emitter.on(eventName, listener);
        /**
         * Wait for the next instance of an event. A promise is returned that will
         * resolve to the event data.
         */
        this.once = (eventName) => this.emitter.once(eventName);
        /**
         * Remove all listeners
         */
        this.clearListeners = () => this.emitter.clearListeners();
        this.emitter = new emittery_1.default();
    }
}
exports.EventEmitter = EventEmitter;
